
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/top-bar.kpa`,
      template: `<div class="top-bar box-shadow" ref="top-bar">
    <div class="logo">
        <a href="{{url}}">
            <img src="/images/logo.png" alt="Logo" /> 
        </a>
    </div>

    <a href="tel:+4922194085999" class="tel-link">+49 (0) 221 94085999</a>

    <span class="spacer"></span>

     <nav class="top-nav" ref="top-nav">
        <ul>
            <li><a href="/home">Home</a></li>
            <li>
                <a href="/ueberuns">Über Uns</a>

                <ul class="box-shadow">
                    <li><a href="/ueberuns/fachkompetenz">Fachkompetenz</a></li>
                    <li><a href="/ueberuns/infrastruktur">Infrastruktur</a></li>
                    <li><a href="/ueberuns/automatisierung">Automatisierung</a></li>
                    <li><a href="/ueberuns/objektakte">Objektakte</a></li>
                </ul>
            </li>
            <li>
                <a href="/leistungen">Leistungen</a>

                <ul class="box-shadow">
                    <li><a href="/leistungen/objektpflege">Objektpflege</a></li>
                    <li><a href="/leistungen/hausmeisterservice">Hausmeisterservice</a></li>
                    <li><a href="/leistungen/instandhaltung">Instandhaltung</a></li>
                </ul>
            </li>
            <li><a href="/referenzen">Referenzen</a></li>
            <li><a href="/home#kontakt">Kontakt</a></li>
        </ul>
     </nav>

    <div class="toggle-nav">
        <button id="menu-toggle" aria-label="Toggle menu" onClick="toggleMenu">
            <!-- Hamburger Icon -->
            <svg id="menu-icon" ref="menu-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke="#2c4143" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
            <!-- Close Icon (initially hidden) -->
            <svg id="close-icon" ref="close-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke="#2c4143" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x" style="display:none;">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
    </div>
</div>
     
<nav class="side-nav box-shadow" ref="side-nav">
    <div class="blur"></div>
    <ul>
        <li><a href="/home">Home</a></li>
        <li>
            <a href="/ueberuns">
                <span>Über Uns</span>
                <span class="open-sub"><i class="fa-solid fa-caret-down"></i></span>
            </a>

            <ul>
                <li><a href="/ueberuns/fachkompetenz">Fachkompetenz</a></li>
                <li><a href="/ueberuns/infrastruktur">Infrastruktur</a></li>
                <li><a href="/ueberuns/automatisierung">Automatisierung</a></li>
                <li><a href="/ueberuns/objektakte">Objektakte</a></li>
            </ul>
        </li>
        <li>
            <a href="/leistungen">
                <span>Leistungen</span>
                <span class="open-sub"><i class="fa-solid fa-caret-down"></i></span>
            </a>

            <ul>
                <li><a href="/leistungen/objektpflege">Objektpflege</a></li>
                <li><a href="/leistungen/hausmeisterservice">Hausmeisterservice</a></li>
                <li><a href="/leistungen/instandhaltung">Instandhaltung</a></li>
            </ul>
        </li>
        <li><a href="/referenzen">Referenzen</a></li>
        <li><a href="/home#kontakt">Kontakt</a></li>

        <li class="social">
            <div class="wrapper">
                <a href="tel:+4922194085999" class="normal-link">
                    <i class="fa-solid fa-phone"></i>
                </a>

                <a href="mailto:hallo@fase2.de?subject=Anfrage" class="normal-link">
                    <i class="fa-solid fa-envelope"></i>
                </a>

                <a href="https://www.instagram.com/fase2_nrw/" class="normal-link" aria-label="FASE2 auf Instagram">
                    <i class="fa-brands fa-instagram"></i>
                </a>
            </div>
        </li>
    </ul>
    <div onClick="closeMenu"></div>
</nav>`,
      style: `@charset "UTF-8";
top-bar {
  /* SIDE NAV */
}
top-bar .top-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  height: 96px;
  padding: 0 16px;
  background-color: rgb(255, 255, 255);
  z-index: 1000;
  border-bottom: 3px solid #64c16c;
}
top-bar .top-bar div {
  padding: 8px 0;
}
top-bar .top-bar .logo {
  height: 80px;
  width: auto;
  align-self: center;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
top-bar .top-bar .logo a {
  display: block;
  width: inherit;
  height: inherit;
  overflow: hidden;
}
top-bar .top-bar .logo img {
  height: 100%;
}
top-bar .top-bar .tel-link {
  display: block;
  height: 25px;
  color: var(--accent-color);
  align-self: center;
  font-weight: 700;
  font-size: 0.9rem;
  margin-left: 8px;
}
top-bar .top-bar nav {
  padding: 0;
}
top-bar .top-bar nav ul {
  display: flex;
  flex-flow: row nowrap;
  padding: 16px 12px;
  margin: 0;
}
top-bar .top-bar nav ul li {
  position: relative;
  list-style-type: none;
  margin: 0 16px;
}
top-bar .top-bar nav ul li a {
  position: relative;
  display: block;
  height: 32px;
  text-decoration: none;
  color: #2e4345;
  text-align: center;
  white-space: nowrap;
  line-height: 32px;
}
top-bar .top-bar nav ul li a:hover, top-bar .top-bar nav ul li a.active {
  text-decoration: none;
  color: #64c16c;
}
top-bar .top-bar nav ul li > a:is(:has(+ ul)) { /* a of parent li */
  margin-right: 24px;
}
top-bar .top-bar nav ul li > a:is(:has(+ ul))::after { /* a of parent li */
  content: "\\f0d7";
  font-family: "Font Awesome 6 Free"; /* Name der FontAwesome-Font */
  font-weight: 900; /* Für Solid-Icons (FontAwesome Free Solid) */
  position: absolute;
  top: 0;
  left: calc(100% + 4px);
  width: 16px;
  height: 100%;
}
top-bar .top-bar nav ul li:has(> ul) { /* parent li */ }
top-bar .top-bar nav ul li:has(> ul):hover { /* parent li hover */ }
top-bar .top-bar nav ul li.hover::after { /* parent li hover */
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 33px;
}
top-bar .top-bar nav ul li > ul { /* Child ul */
  flex-flow: column nowrap;
  position: absolute;
  top: calc(100% + 33px);
  left: 50%;
  transform: translateX(-50%);
  display: none;
  background-color: #ffffff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
top-bar .top-bar nav ul li > ul li {
  padding: 8px 0;
}
top-bar .top-bar nav ul li > ul li:last-of-type {
  margin: 0 16px;
}
top-bar .top-bar nav ul li.hover > ul,
top-bar .top-bar nav ul li > ul.hover { /* Child ul show */
  display: flex;
}
top-bar .top-bar nav ul li:first-of-type {
  margin: 0 16px 0 0;
}
top-bar .top-bar nav ul li:last-of-type {
  margin: 0 0 0 16px;
}
top-bar .top-bar nav ul + div {
  display: none;
}
top-bar .top-bar .spacer {
  flex-grow: 1;
}
top-bar .top-bar .toggle-nav {
  display: none;
  align-self: center;
}
top-bar .top-bar .toggle-nav button {
  width: 48px;
  height: 48px;
  border: 0;
  color: black;
  background-color: transparent;
  padding: 12px;
  cursor: pointer;
}
top-bar .top-bar .toggle-nav #menu-toggle {
  box-shadow: none;
}
@media (max-width: 992px) {
  top-bar .top-bar nav.top-nav {
    display: none;
  }
  top-bar .top-bar .toggle-nav {
    display: block;
  }
}
@media (max-width: 992px) {
  top-bar .top-bar {
    position: fixed;
    top: 0;
    background-color: rgb(255, 255, 255);
  }
  top-bar nav.side-nav {
    display: block;
    position: fixed;
    top: 64px;
    left: 0;
    width: 0;
    height: calc(100vh - 64px);
    padding: 0;
    transition: width 0s linear 0.5s, background-color 0.5s ease-in-out;
    z-index: 100;
  }
  top-bar nav.side-nav > ul {
    display: flex;
    padding: 0;
    margin: 0;
    flex-flow: column nowrap;
    position: absolute;
    top: 0;
    left: -310px;
    width: 260px;
    height: 100%;
    transform: translateX(0);
    background-color: rgb(255, 255, 255);
    transition: transform 0.2s ease-in-out 0s;
    z-index: 2;
  }
  top-bar nav.side-nav > ul li {
    list-style-type: none;
  }
  top-bar nav.side-nav > ul li a {
    display: block;
    text-decoration: none;
    color: black;
    padding: 8px 0 8px 16px;
    line-height: 32px;
  }
  top-bar nav.side-nav > ul li a.active {
    text-decoration: none;
    color: #64c16c;
  }
  top-bar nav.side-nav > ul li a.active span {
    color: #64c16c;
  }
  top-bar nav.side-nav > ul li > a:is(:has(+ ul)) { /* a of parent li */
    position: relative;
    display: flex;
  }
  top-bar nav.side-nav > ul li > a:is(:has(+ ul)) span {
    display: inline-block;
  }
  top-bar nav.side-nav > ul li > a:is(:has(+ ul)) span:first-of-type {
    padding-right: 8px;
  }
  top-bar nav.side-nav > ul li > a:is(:has(+ ul)) span:last-of-type {
    flex-grow: 1;
  }
  top-bar nav.side-nav > ul li:has(> ul) { /* parent li */
    overflow: hidden;
  }
  top-bar nav.side-nav > ul li:has(> ul) > ul { /* Child ul */
    flex-flow: column nowrap;
    position: relative;
    display: none;
    padding: 0;
    margin: 0;
    background-color: #f2f2f1;
  }
  top-bar nav.side-nav > ul li:has(> ul) > ul li a {
    padding: 8px 0 8px 32px;
  }
  top-bar nav.side-nav > ul li:has(> ul) > ul.open { /* Child ul open */
    display: flex;
  }
  top-bar nav.side-nav > ul li.social {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  top-bar nav.side-nav > ul li.social .wrapper {
    padding: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
  top-bar nav.side-nav > ul li.social .wrapper a {
    width: 32px;
    height: 32px;
    color: #2c4143;
    text-align: center;
    line-height: 32px;
    padding: 0;
  }
  top-bar nav.side-nav > ul li.social .wrapper a:hover {
    color: #64c16c;
  }
  top-bar nav.side-nav .blur {
    height: 100%;
    -webkit-backdrop-filter: blur(0);
            backdrop-filter: blur(0);
    transition: left 0.2s ease-in-out 0s, -webkit-backdrop-filter 0.4s ease-in-out 0s;
    transition: left 0.2s ease-in-out 0s, backdrop-filter 0.4s ease-in-out 0s;
    transition: left 0.2s ease-in-out 0s, backdrop-filter 0.4s ease-in-out 0s, -webkit-backdrop-filter 0.4s ease-in-out 0s;
  }
  top-bar nav.side-nav > ul + div {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0);
    transition: left 0.2s ease-in-out 0s, background-color 0.4s ease-in-out 0s;
  }
  top-bar nav.side-nav.show {
    width: 100%;
    backround-position: 260px 260px;
    transition: width 0s linear 0s;
  }
  top-bar nav.side-nav.show > ul {
    transform: translateX(310px);
    transition: transform 0.3s ease-in-out 0s;
  }
  top-bar nav.side-nav.show .blur {
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    transition: left 0.3s ease-in-out 0s, -webkit-backdrop-filter 0.5s ease-in-out 0s;
    transition: left 0.3s ease-in-out 0s, backdrop-filter 0.5s ease-in-out 0s;
    transition: left 0.3s ease-in-out 0s, backdrop-filter 0.5s ease-in-out 0s, -webkit-backdrop-filter 0.5s ease-in-out 0s;
  }
  top-bar nav.side-nav.show > ul + div {
    left: 260px;
    background-color: rgba(0, 0, 0, 0.4);
    transition: left 0.3s ease-in-out 0s, background-color 0.5s ease-in-out 0s;
  }
}
@media (min-width: 993px) {
  top-bar nav.side-nav {
    display: none;
  }
}
@media (max-width: 992px) {
  top-bar .top-bar {
    height: 64px;
  }
  top-bar .top-bar .logo {
    height: 50px;
  }
}
@media (max-width: 420px) {
  top-bar .top-bar .tel-link {
    display: none;
    color: #2e4345;
  }
}

top-bar li {
  margin: 0;
  padding: 0;
}`,
      script: `(async () => { "use strict";
return {
    data: {
        url: window.location.origin,
    },
    methods: {
        toggleMenu(event) {
            const menuIcon = $refs['menu-icon'];
            const closeIcon = $refs['close-icon'];
            const sideNav = $refs['side-nav'];
            sideNav.classList.toggle('show');
            if (sideNav.classList.contains('show')) {
                menuIcon.style.display = 'none';
                closeIcon.style.display = 'block';
            }
            else {
                menuIcon.style.display = 'block';
                closeIcon.style.display = 'none';
            }
        },
        closeMenu(event) {
            const menuIcon = $refs['menu-icon'];
            const closeIcon = $refs['close-icon'];
            const sideNav = $refs['side-nav'];
            sideNav.classList.remove('show');
            menuIcon.style.display = 'block';
            closeIcon.style.display = 'none';
        },
        generateHrefCombinations(href) {
            const url = new URL(href, window.location.origin);
            const full = url.pathname + url.search + url.hash;
            const base = url.pathname;
            const pathSegments = base.split('/').filter(Boolean);
            const combinations = [];
            for (let i = pathSegments.length; i > 0; i--) {
                combinations.push('/' + pathSegments.slice(0, i).join('/'));
            }
            if (full !== base) {
                combinations.unshift(full);
            }
            return combinations;
        },
        markParent() {
            [$refs['top-nav'], $refs['side-nav']].filter(Boolean).forEach(nav => {
                const dropdowns = Array.from(nav.querySelectorAll('li')).filter(li => {
                    return li.select(':scope > ul') !== null;
                });
                dropdowns.forEach(li => {
                    li.addClass('dropdown');
                });
            });
        },
        updateNavLinks(nav, hrefCombinations) {
            nav.querySelectorAll('a:not(.normal-link)').forEach(link => {
                const linkHref = link.getAttribute('href');
                if (hrefCombinations.includes(linkHref)) {
                    link.classList.add('active');
                }
                else {
                    link.classList.remove('active');
                }
            });
        },
        toggleActive() {
            const currentPath = window.location.pathname === '/' ? '/home' : window.location.pathname;
            const fullHref = currentPath + window.location.search + window.location.hash;
            [$refs['top-nav'], $refs['side-nav']].filter(Boolean).forEach(nav => {
                nav.querySelectorAll('a:not(.normal-link)').forEach(link => {
                    const linkHref = link.getAttribute('href');
                    const li = link.closest('li');
                    const subUl = li?.querySelector('ul');
                    const isActive = linkHref === fullHref;
                    if (isActive) {
                        link.classList.add('active');
                        li?.classList.add('active');
                        subUl?.classList.add('open');
                        let parent = li?.parentElement?.closest('li');
                        while (parent) {
                            parent.classList.add('active');
                            const parentLink = parent.querySelector('a[href]');
                            parentLink?.classList.add('active');
                            const parentSub = parent.querySelector('ul');
                            parentSub?.classList.add('open');
                            parent = parent.parentElement?.closest('li');
                        }
                    }
                    else {
                        link.classList.remove('active');
                        li?.classList.remove('active');
                        subUl?.classList.remove('open');
                    }
                });
            });
        },
        toggleSub(event) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                const sub = event.target.closest('a').nextElementSibling;
                if (sub && sub.tagName === 'UL') {
                    sub.classList.toggle('open');
                }
                event.target.closest('ul').querySelectorAll('ul').forEach(ul => {
                    if (ul.classList.contains('open') && ul !== sub) {
                        ul.classList.remove('open');
                        console.log(\`Klasse 'open' von $-{ul} entfernt.\`);
                    }
                });
            }, 100);
        },
    },
    beforeMount() {
        this.markParent();
    },
    mounted() {
        this.toggleActive();
    },
    events: [
        ['routechange', window, function (event) {
                this.toggleActive();
            }],
        ['click', 'nav.top-nav a:not(.normal-link)', function (event) {
                event.stopPropagation();
                event.preventDefault();
                router.navigate(event.target.closest('a').getAttribute('href'));
            }],
        ['mouseenter', 'nav.top-nav li:has(> ul)', function (event) {
                const target = event.target.closest('li');
                const subNav = target.children[1];
                target.addClass('hover');
            }],
        ['mouseleave', 'nav.top-nav li:has(> ul)', function (event) {
                const target = event.target.closest('li');
                const subNav = target.children[1];
                target.removeClass('hover');
            }],
        ['mouseenter', 'nav.top-nav li:has(> ul) > ul', function (event) {
                const target = event.target.closest('ul');
                target.addClass('hover');
            }],
        ['mouseleave', 'nav.top-nav li:has(> ul) > ul', function (event) {
                const target = event.target.closest('ul');
                target.removeClass('hover');
            }],
        ['click', 'nav.side-nav a:not(.normal-link)', function (event) {
                event.preventDefault();
                this.closeMenu(event);
                router.navigate(event.target.closest('a').getAttribute('href'));
                this.toggleSub(event);
            }],
        ['click', 'nav.side-nav a .open-sub', function (event) {
                event.preventDefault();
                event.stopPropagation();
                this.toggleSub(event);
            }],
        ['click', 'nav.side-nav li:has(> ul) > a', function (event) {
                event.preventDefault();
                const parentLi = event.target.closest('li');
                const subUl = parentLi.querySelector('ul');
                if (subUl) {
                    subUl.classList.toggle('open');
                }
                const allLis = $refs['side-nav'].querySelectorAll('li');
                allLis.forEach(li => li.classList.remove('active'));
                parentLi.classList.add('active');
                const href = event.target.getAttribute('href');
                if (href) {
                }
            }]
    ]
};
 })()`
    };
  